import React from 'react'

interface ICheckedProps {
  color?: string
}

const defaultProps: ICheckedProps = {
  color: '#142C8E',
}

export const Checked: React.FC<ICheckedProps> = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99999 19.3333C15.1546 19.3333 19.3333 15.1546 19.3333 9.99999C19.3333 4.84533 15.1546 0.666656 9.99999 0.666656C4.84533 0.666656 0.666656 4.84533 0.666656 9.99999C0.666656 15.1546 4.84533 19.3333 9.99999 19.3333ZM14.3311 6.25259C14.7438 6.61951 14.781 7.25158 14.4141 7.66436L9.08077 13.6644C8.88498 13.8846 8.60201 14.0073 8.30741 13.9997C8.01281 13.992 7.73659 13.8548 7.55249 13.6247L4.88583 10.2914C4.54081 9.8601 4.61074 9.23081 5.042 8.8858C5.47326 8.54079 6.10255 8.61071 6.44756 9.04197L8.37361 11.4495L12.9193 6.33564C13.2862 5.92285 13.9183 5.88567 14.3311 6.25259Z"
        fill="#142C8E"
      />
    </svg>
  )
}

Checked.defaultProps = defaultProps
